export const LOGIN = "LOGIN";
export const UPDATE_PASSWORD_FORM = "UPDATE_PASSWORD_FORM";
export const RESET_PASSWORD_FORM = "RESET_PASSWORD_FORM";
export const SET_NEW_PASSWORD_FORM = "SET_NEW_PASSWORD_FORM";
export const REFERENCE_SEARCH_FORM = "REFERENCE_SEARCH_FORM";